import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Input,
  Button,
  Spinner,
  Icon,
  MediaObject,
} from '@salesforce/design-system-react';

const QuipModal = (props) => {
  return (
    <Card
      hasNoHeader
      className="slds-p-horizontal_small"
      style={{
        backgroundColor: '#f3f3f3',
        border: '1px solid #ccc',
      }}
    >
      <MediaObject
        body={
          <span>
            <strong>Step 1: &nbsp;</strong>
            Generate the Journey Quip Document
          </span>
        }
        figure={
          <Icon
            category="standard"
            name="quip"
            size="medium"
            containerStyle={{
              backgroundColor: 'rgb(242, 117, 87)',
            }}
          />
        }
        verticalCenter
      />
      {props.isLoading ? (
        <Spinner assistiveText={{ label: 'loading' }} />
      ) : null}
      <div className="slds-p-horizontal_x-small">
        <div
          className="slds-text-heading_small slds-m-around_small slds-p-around_small"
          style={{
            border: '1px solid #ddd',
            backgroundColor: '#fff',
            borderRadius: '3px',
          }}
        >
          Required:&nbsp;
          <a
            href="https://salesforce.quip.com/dev/token"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click Here&nbsp;
          </a>
          to obtain your Quip Access Token
        </div>
        {props.error ? (
          <div className="slds-text-align_center slds-text-color_error slds-m-around_small">
            {props.error}
          </div>
        ) : null}

        <Input
          className="slds-m-around_small"
          label="Paste Your Quip Token Below"
          required
          value={props.quipToken}
          onChange={props.onQuipChange}
          placeholder="Enter Quip Token Here"
        ></Input>

        <Button
          className="slds-align_absolute-center slds-m-bottom_small"
          variant="brand"
          label="Generate Quip"
          disabled={!props.quipToken}
          onClick={props.onSave}
        ></Button>
      </div>
    </Card>
  );
};

QuipModal.propTypes = {
  quipToken: PropTypes.string.isRequired,
  error: PropTypes.string,
  onQuipChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default QuipModal;
